<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>生成码记录信息</span>
      </div>
      <el-form
        ref="createCodeForm"
        :model="createCodeInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label="区域：" prop="typeCode">
            <el-select
              v-model="createCodeInfo.typeCode"
              clearable
              placeholder="请选择区域"
            >
              <el-option
                v-for="item in productTypeOptions"
                :key="item.typeCode"
                :label="item.typeName"
                :value="item.typeCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="起始值：" prop="startCode">
            <el-input
              v-model="createCodeInfo.startCode"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="生成数量：" prop="createCount">
            <el-input
              v-model="createCodeInfo.createCount"
              :onblur="getVal(createCodeInfo.createCount)"
            ></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最大不超过10万</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="终止值：" prop="endCode">
            <el-input
              v-model="createCodeInfo.endCode"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="服务地址：" prop="serviceUrl">
            <el-input v-model="createCodeInfo.serviceUrl"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入200个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      productTypeOptions: [],
      createCodeInfo: {
        createCodeRecordId: "",
        typeCode: "",
        createCount: "",
        startCode: "",
        endCode: "",
        serviceUrl: ""
      },
      rules: {
        typeCode: [
          {
            required: true,
            message: "请选择区域",
            trigger: "blur"
          }
        ],
        createCount: [
          {
            required: true,
            message: "请输入生成数量",
            trigger: "blur"
          },
          {
            validator: this.validateCom,
            message: "最大不超过10万",
            trigger: "change"
          }
        ],
        serviceUrl: [
          {
            max: 200,
            message: "最多输入200个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    validateCom(rule, value, callback) {
      const one = Number(value);
      if (one > 100000) {
        return callback(new Error("输入值最大不超过10万"));
      }
      return callback();
    },
    getVal(value) {
      if (value !== "") {
        const createCount = Number(value);
        this.createCodeInfo.endCode = 10000000 + createCount;
      }
    },
    add() {
      let _this = this;
      _this.$refs.createCodeForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/createCode/saveCreateCodeInfo",
            params: {
              createCodeRecordId: _this.createCodeInfo.createCodeRecordId,
              typeCode: _this.createCodeInfo.typeCode,
              createCount: _this.createCodeInfo.createCount,
              startCode: _this.createCodeInfo.startCode,
              endCode: _this.createCodeInfo.endCode,
              serviceUrl: _this.createCodeInfo.serviceUrl
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "已售产品码添加成功",
                  type: "success"
                });
                this.$router.push({
                  name: "createCodeIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善已售产品码信息!",
            type: "warning"
          });
        }
      });
    },
    getProductTypeList() {
      let _this = this;
      let param = {
        url: "/api/productType/getProductTypeList"
      };

      _this.$store.dispatch("getProductTypeList", param).then(() => {
        _this.productTypeOptions =
          _this.$store.state.productType.productTypeList;
      });
    }
  },
  created() {
    let _this = this;
    _this.getProductTypeList();
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
